<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model layout="inline" class="search-form1">
      <a-form-model-item label="数据百分比" prop="percent">
        <a-input-number v-model="form.percent" :min="0" :max="100" @change="handleChange" />
      </a-form-model-item>
      <a-form-model-item requirement-type label="阶段时间">
        <a-input-group compact>
          <a-select v-model="form.searchTimeType" style="width: 26%" @change="handleChange">
            <a-select-option v-for="it in requirementStatus" :key="it.id" :value="it.id"> {{ it.title }} </a-select-option>
          </a-select>
          <a-date-picker v-model="form.startTime" style="width: 37%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
          <a-date-picker v-model="form.endTime" style="width: 37%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
        </a-input-group>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import store from '@/store';
export default {
  name: 'DataFilter',
  data() {
    return {
      form: {
        searchTimeType: 135,
        percent: 100,
        startTime: '',
        endTime: ''
      }
    };
  },

  computed: {
    brPoList() {
      const list = [];
      if (store.state.globalConfigList) {
        const orgList = store.state.globalConfigList.br_po || [];
        return orgList.map(item => {
          return {
            nickname: item.nickname,
            id: item.user_id
          };
        });
      }
      return list;
    },
    requirementStatus() {
      const stepList = [];
      if (store.state.globalConfigList) {
        let stepMap = this.$store.getters.getGlobalBusinessStatus();
        const keysToKeep = ['135', '136', '137', '138', '139', '140'];
        stepMap = Object.keys(stepMap)
          .filter(key => keysToKeep.includes(key))
          .reduce((result, key) => {
            result[key] = stepMap[key];
            return result;
          }, {});

        for (const key in stepMap) {
          const o = stepMap[key];
          stepList.push({ id: parseInt(key), title: o ? o.title : key, sort: o ? o.sort : 0 });
        }
      }
      return stepList;
    }
  },

  watch: {
    filter() {}
  },
  created() {
    this.handleChange();
  },

  methods: {
    handleChange() {
      this.$emit('change', this.form);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.search-form1 .ant-form-item {
  display: inline-block !important;
}

.ant-form-item {
  margin-bottom: 0px;
}
</style>
